import axios from 'axios';

const API_URL = 'https://dailyreportsapi.winggs.in/api/reports';
// const API_URL = 'http://localhost:5000/api/reports'; // Use this for local development

const reportService = {
  // Create a new report
  createReport: async (reportData) => {
    const response = await axios.post(API_URL, reportData);
    return response.data;
  },
  // Get current user's reports
  getUserReports: async (page = 1, limit = 10) => {
    console.log('Fetching user reports with task details');
    const response = await axios.get(`${API_URL}/me?page=${page}&limit=${limit}&include_task_details=true`);
    // Debug log for task details
    console.log("response",response)
    if (response.data && response.data.reports) {
      response.data.reports.forEach(report => {
        console.log(`Report ${report.id}: has task_details: ${!!(report.task_details && report.task_details.length)}, count: ${report.task_details ? report.task_details.length : 0}`);
      });
    }
    return response.data;
  },

  // Get all reports (admin only)
  getAllReports: async (filters = {}, page = 1, limit = 10) => {
    let url = `${API_URL}?page=${page}&limit=${limit}&include_task_details=true`;
    
    if (filters.userId) url += `&userId=${filters.userId}`;
    if (filters.date) url += `&date=${filters.date}`;
    if (filters.startDate) url += `&startDate=${filters.startDate}`;
    if (filters.endDate) url += `&endDate=${filters.endDate}`;
    if (filters.projectId) url += `&projectId=${filters.projectId}`;
    
    console.log('Fetching admin reports with URL:', url);
    const response = await axios.get(url);
    
    // Debug log for task details
    if (response.data && response.data.reports) {
      response.data.reports.forEach(report => {
        console.log(`Admin Report ${report.id}: has task_details: ${!!(report.task_details && report.task_details.length)}, count: ${report.task_details ? report.task_details.length : 0}`);
      });
    }
    
    return response.data;
  },

  // Get a single report by ID
  getReportById: async (id) => {
    console.log('Fetching single report with task details');
    const response = await axios.get(`${API_URL}/${id}?include_task_details=true`);
    console.log("responsesssssssssss",response)
    // Debug log for task details
    if (response.data) {
      console.log(`Single Report ${id}: has task_details: ${!!(response.data.task_details && response.data.task_details.length)}, count: ${response.data.task_details ? response.data.task_details.length : 0}`);
    }
    
    return response.data;
  },

  // Add a comment to a report
  addComment: async (reportId, comment, parentId = null) => {
    const response = await axios.post(`${API_URL}/${reportId}/comments`, { 
      comment,
      parent_id: parentId
    });
    return response.data;
  },

  // Update an existing report (same day only for developers)
  updateReport: async (id, reportData) => {
    const response = await axios.put(`${API_URL}/${id}`, reportData);
    return response.data;
  },

  // Get project hours by project ID (with optional role filter)
  getProjectHours: async (projectId, role = null) => {
    let url = `${API_URL}/project/${projectId}/hours`;
    
    // Add role filter if specified
    if (role) {
      url += `?role=${role}`;
    }
    
    console.log('Fetching project hours with URL:', url);
    const response = await axios.get(url);
    return response.data;
  },

  // Export reports to CSV (admin only)
  exportReports: async (filters = {}) => {
    let url = `${API_URL}/export`;
    const queryParams = [];

    if (filters.userId) queryParams.push(`userId=${filters.userId}`);
    if (filters.projectId) queryParams.push(`projectId=${filters.projectId}`);
    if (filters.startDate && filters.endDate) {
      queryParams.push(`startDate=${filters.startDate}&endDate=${filters.endDate}`);
    }

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    try {
      // Use axios instead of window.location to include auth headers
      const response = await axios.get(url, { responseType: 'blob' });

      // Create a blob URL and trigger download
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', `reports-${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return true;
    } catch (error) {
      console.error('Error exporting reports:', error);
      throw error;
    }
  },

  // Get project summary data (all reports for a specific project)
  getProjectSummary: async (projectId, userId = null) => {
    try {
      const params = { projectId, includeTaskDetails: true, limit: 1000 };
      if (userId) params.userId = userId;

      const response = await axios.get(`${API_URL}/project-summary`, { params });
      return response.data.reports || [];
    } catch (error) {
      console.error('Error fetching project summary:', error);
      throw error;
    }
  }
};

export default reportService;
